import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { arrowBack } from '../../utilities/icons';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInOrganisationSupportProfilesManager extends AllInOrganisationConsumer(LitElement) {
    static properties = {
        ...super.properties,
        currentOrg: { type: String, reflect: true },
        panel: { type: String, reflect: true },
        name: { type: String },
        view: { type: String },
        _profiles: { state: true, type: Array },
        _loading: { state: true, type: Boolean },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager.initHistory({ panel: this.panel ?? '', view: this.view ?? '' });
        if (!this.currentOrg) {
            this._loading = true;
        }
        if (this.panel) {
            this._showPanel(this.panel, this.view);
        }
        this.renderRoot.querySelector('button,a')?.focus();
        this.partial = false;
        const urlParams = new URLSearchParams(window.location.search);
        const partial = urlParams.get('success');
        if (partial && partial == 'partial') {
            this.partial = true;
            let url = new URL(window.location.href);
            url.searchParams.delete('success');
            window.history.replaceState({}, '', url);
        }
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    updated(changedProperties) {
        if (changedProperties.has('currentOrg')) {
            this.organisation = this._getOrganisationById(this.currentOrg);
            this._loading = false;
        }
        if (changedProperties.has('panel') || changedProperties.has('view')) {
            this._showPanel(this.panel, this.view);
            this.renderRoot.querySelector('button,a')?.focus();
        }
        cardLinks(this.shadowRoot);
    }
    render() {
        let main = '';
        if (this._loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            let button = html `<button class="back" @click=${this._hidePanel}><span aria-hidden="true">${arrowBack}</span>Return to support profiles</button>`;
            if (this.panel == 'add') {
                main = html `\n                ${button}\n                <allin-organisation-support-profile-form currentOrg=${this.currentOrg} view="add"></allin-organisation-support-profile-form>\n                `;
            }
            else if (this.panel) {
                main = html `\n                    ${button}\n                    <allin-organisation-support-profile-form currentOrg=${this.currentOrg} profile=${this.panel} view=${this.view}></allin-organisation-support-profile-form>\n                `;
            }
            else {
                main = html `\n                    <allin-organisation-support-profiles currentOrg=${this.currentOrg}></allin-organisation-support-profiles>\n                `;
            }
        }
        return html `${main}`;
    }
    _showPanel(panel, view) {
        let name = '';
        if (this.panel == 'add') {
            name = 'New Support Profile';
        }
        else if (this.panel) {
            this.profile = this._getProfileById(this.panel);
            if (this.profile) {
                name = this.profile.name;
            }
            else {
                name = 'Support Profile';
            }
        }
        if (view) {
            panel += `/${view}`;
        }
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name}` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/support/`, title: `Support profiles` },
            panel: { url: `/organisation-dashboard/${this.currentOrg}/support/${panel}`, title: name }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, { crumb });
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/support/' + panel, { panel: this.panel });
    }
    _hidePanel() {
        this.panel = '';
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name}` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/support/`, title: `Support profiles` }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/support', { panel: '' });
        this._updateContext({ panel: '', view: '' });
        this.partial = false;
    }
    _handleContextUpdate(value) {
        super._handleContextUpdate(value);
        let prevPanel = this.panel;
        if (this.panel && this.panel != prevPanel) {
            this._showPanel(this.panel, this.view);
        }
    }
    _getProfileById(id) {
        return this.organisation?.profiles?.find(p => p.id == id);
    }
    static styles = [
        accessibility,
        formStyles,
        grid,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }


        h3,p{
            margin:0;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }

        `
    ];
}
